import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { FormLogin } from './FormLogin';
import image from '../../static/image/3.png';

export const LoginPage = () => {

	const { isAuthenticated } = useSelector((state) => state.user);
	
	if (isAuthenticated) {
		return <Navigate to="/" replace />;
	}
	
	return (
		<div className='w-full flex'>
			<div className='w-full h-screen lg:w-[40%] flex flex-col min-h-0'>
				<FormLogin />
			</div>
			<div
				className='w-0 lg:w-[60%] h-screen bg-cover'
				style={{ backgroundImage: `url(${image})` }}
			></div>
		</div>
	);
};
